"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchListingsData = void 0;
const polaris_client_utils_1 = require("@noths/polaris-client-utils");
const config_1 = require("../common/config");
const DEFAULT_TIMEOUT = 5000;
const fetchListingsData = ({ body, clientSide = false, env, servingConfig, timeout = DEFAULT_TIMEOUT, userId, visitorId, }) => __awaiter(void 0, void 0, void 0, function* () {
    const envConfig = config_1.API_URLS.listings[env];
    const requestUrl = clientSide ? envConfig.clientSide : envConfig.serverSide;
    if (!visitorId) {
        throw new Error(`visitorId must be specified`);
    }
    const apiResponse = yield (0, polaris_client_utils_1.fetchJSONWithTimeout)(requestUrl, {
        method: 'POST',
        timeout,
        headers: Object.assign(Object.assign(Object.assign({}, (userId && { 'noths-user-id': userId })), { 'noths-visitor-id': visitorId, 'Content-Type': 'application/json' }), (servingConfig && { 'noths-serving-config': servingConfig })),
        body: body,
    });
    const data = yield apiResponse.json();
    if (apiResponse.ok) {
        return data;
    }
    if (data.message) {
        return data;
    }
    return data;
});
exports.fetchListingsData = fetchListingsData;
